import React from 'react';
import Slider from 'components/Slider';

import trade from './images/trade.png';
import welcomeInset from './images/welcome-inset.png';
import invitationInset from './images/invitation-inset.png';
import investInset from './images/invest-inset.png';
import './style.scss';

class Banner extends React.Component {
    render() {
        return (
            <Slider className="banner-root">
                <div className="invest-banner">
                    <div className="site-main a-flyTopIn">
                        <div className="welcome-banner-body">
                            <div className="left-title">
                                <h2 className="first-line">1.99% Flat Margin Rate</h2>
                                <a href="https://invest.tradeup.com/" className="link-btn" target="_blank">
                                    Learn More
                                </a>
                                <p className="slide-explain">
                                    Must have margin account with over $2000 total account equity to qualify for margin
                                    rate.
                                </p>
                                <p className="slide-explain mt-0">
                                    Margin may not be suitable for all investors due to the risks associated with using
                                    leverage. Please review the{' '}
                                    <a href="https://www.marsco.com/static/pdf/MARGIN-DISCLOSURE-STATEMENT.pdf">
                                        Margin Disclosure Statement
                                    </a>{' '}
                                    to determine whether a margin account aligns with your investment objectives and
                                    risk tolerance.
                                </p>
                            </div>
                            <img className="right-img" src={investInset} alt="right-person" />
                        </div>
                    </div>
                </div>
                <div className="welcome-banner">
                    <div className="site-main a-flyTopIn">
                        <div className="welcome-banner-body">
                            <div className="left-title">
                                <h2 className="first-line">TradeUP Welcome Gift</h2>
                                <h2 className="second-line">
                                    Open and fund a new TradeUP account to <br /> receive up to <b>$1800</b> worth of
                                    free stocks!
                                </h2>
                                <a href="/activity/market/welcome?lang=en_US#/" className="link-btn" target="_blank">
                                    Learn more
                                </a>
                            </div>
                            <img className="right-img" src={welcomeInset} alt="right-person" />
                        </div>
                    </div>
                </div>
                <div className="invitation-banner">
                    <div className="site-main a-flyTopIn">
                        <div className="welcome-banner-body">
                            <div className="left-title">
                                <h2 className="first-line">Refer & get rewarded!</h2>
                                <h2 className="second-line">
                                    Invite your friends to TradeUP to both win <br /> up to <b>$1800</b> worth of free
                                    stocks!
                                </h2>
                                <a
                                    href={`/activity/forapp/invitation/?_f=banner&lang=en_US#/`}
                                    className="link-btn"
                                    target="_blank">
                                    Learn more
                                </a>
                            </div>
                            <img className="right-img invitation" src={invitationInset} alt="right-person" />
                        </div>
                    </div>
                </div>
                <div className="at-tradeup">
                    <div className="site-main" data-animation="a-flyTopIn">
                        <div className="banner-container">
                            <div className="left">
                                <h2 className="slide-title">Reimagine Trading At TradeUP!</h2>
                                <p className="slide-des">
                                    Our proprietary FinTech platform helps you trade commission-free with confidence.
                                </p>
                                <a className="slide-btn" href="/accounts?_f=banner">
                                    GET STARTED
                                </a>
                                <p className="slide-explain">
                                    $0.00 commission applies to online U.S. equity trades and exchange-traded funds
                                    (ETFs) in a TradeUP retail account only for TradeUP Securities, Inc. retail clients.
                                    Sell orders are subject to an activity assessment fee. Other exclusions and
                                    conditions may apply. See{' '}
                                    <a href="https://www.tradeup.com/pricing/commissions-us">
                                        https://www.tradeup.com/pricing/commissions-us
                                    </a>{' '}
                                    for details. Institutional accounts, OTC securities trading and other types of
                                    high-touch services are subject to different commission schedules.
                                </p>
                            </div>
                            <div className="right">
                                <img src={trade} alt="trade" className="trade-box" data-animation="a-flyTopIn" />
                            </div>
                        </div>
                    </div>
                </div>
            </Slider>
        );
    }
}

export default Banner;
